import { enumParser } from '#validation/common/parsers';
import { ExternalUsersSsoEnforcement } from '../constants';
export const ssoExternalUserEnforcementParser = enumParser(ExternalUsersSsoEnforcement);
